<template>
  <a v-if="href" :href="href" class="button button-fill">
    {{ text }}
  </a>
</template>

<script>
export default {
  props: {
    text: {
      type: String
    },
    href: {
      type: String
    }
  }
};
</script>
